module.exports = __webpack_public_path__ + "img/arrow-down.77a8ce6a.svg";